import designTokens from './design-tokens.json';

export const tokens = designTokens;

export type TextVariant =
  | 'display'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'body'
  | 'body-sm'
  | 'caption'
  | 'label';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export type BreakpointKey = 'phone' | 'tablet' | 'desktop';

export const colorTokenNames = Object.keys(tokens.colors).filter((key) => key !== 'muted');

export function typographyAt(variant: TextVariant, breakpoint: BreakpointKey) {
  return tokens.typography[variant][breakpoint];
}
